import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../common/SectionHeader';

const LogosSection = styled.section`
  padding: 80px 0;
`;

const LogoCarousel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
`;

const LogoItem = styled.div`
  flex: 1;
  min-width: 200px;
  max-width: 250px;
  text-align: center;
  padding: 20px;
  filter: grayscale(100%);
  opacity: 0.6;
  transition: ${props => props.theme.transitions.main};
  
  &:hover {
    filter: grayscale(0);
    opacity: 1;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    min-width: 150px;
  }
`;

const PartnerLogos = () => {
  // In a real application, this data would come from an API or CMS
  const partners = [
    {
      id: 1,
      name: 'Partner Logo',
      image: '/placeholder/200/100'
    },
    {
      id: 2,
      name: 'Partner Logo',
      image: '/placeholder/200/100'
    },
    {
      id: 3,
      name: 'Partner Logo',
      image: '/placeholder/200/100'
    },
    {
      id: 4,
      name: 'Partner Logo',
      image: '/placeholder/200/100'
    },
    {
      id: 5,
      name: 'Partner Logo',
      image: '/placeholder/200/100'
    }
  ];

  return (
    <LogosSection>
      <div className="container">
        <SectionHeader 
          title="Our Partners & Collaborators" 
          subtitle="Organizations we work with" 
        />
        
        <LogoCarousel>
          {partners.map(partner => (
            <LogoItem key={partner.id}>
              <img src={partner.image} alt={partner.name} />
            </LogoItem>
          ))}
        </LogoCarousel>
      </div>
    </LogosSection>
  );
};

export default PartnerLogos;
